const TOOLTIP_DELAY = 5000;
const TOOLTIP_NUDGE_INTERVAL = 3000;
const FULLSCREEN_WIDGET_BREAKPOINT = 490;

const selectors = {
  tooltip: {
    container: '[data-kenect-text-tooltip]',
    closeButton: '[data-kenect-text-tooltip-close]',
    textContainer: '[data-kenect-text-tooltip-text]',
  },
  trigger: {
    container: '[data-kenect-text-trigger]',
  },
};

const settings = {
  tooltipText: {
    desktop: 'Have a question? Chat with us!',
    mobile: 'Questions? Chat with us!',
  },
};

export {
  FULLSCREEN_WIDGET_BREAKPOINT,
  TOOLTIP_DELAY,
  TOOLTIP_NUDGE_INTERVAL,
  selectors,
  settings,
};
